import React from 'react';
import { addCommasToBigNumbers } from '../../util/helperFunctions';
import Bold from '../Bold';

export default function DisplayTotalTime({ totalTime, startDate, endDate, animalType }) {
	return (
		<p>
			Between <Bold>{startDate}</Bold> and{' '}
			<Bold>{endDate}</Bold> we have spent{' '}
			<Bold>
				{addCommasToBigNumbers(Math.round(totalTime))} minutes
			</Bold>{' '}
			enriching {animalType}s.
		</p>
	);
}
